import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import InventoryFilter from "../filter"
import { searchPayTermTemplate } from "../../../services/Inventory/inventory"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useDispatch, useSelector } from "react-redux"
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter"
import { driverSet } from "../../../store/guide/action"
import EditPayTermsTemplate from "./edit"
import { useLocation } from "react-router-dom"

const PaymentTermsTemplateSearch = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Payment Terms Template${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const dispatch = useDispatch()

  const [editClass, setEditClass] = useState({
    modal: false,
    value: "",
    id: "",
    ptt: false,
  })
  const [refresh, setRefresh] = useState(0)
  const [dataPerPage, setDataPerPage] = useState(25)

  const handleUpdate = () => {
    setRefresh(refresh + 1)
  }
  const handleReset = () => {
    setEditClass({
      modal: false,
      value: "",
      id: "",
      ptt: false,
    })
  }

  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [series, setSeries] = useState("")
  const [search, setSearch] = useState("")
  const [page, setPage] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const handleEdit = item => {
    setEditClass({ modal: false, value: item, id: item?.id, ptt: true })
  }

  const columns = [
    {
      label: "Code",
      renderCell: (item, index) => item?.code,
    },
    {
      label: "Payment Term Template Name",
      renderCell: item => (item?.name ? item?.name : "-"),
    },
    // {
    //   label: "Invoice Portion (%)",
    //   renderCell: item =>
    //     item?.invoice_portion ? `${item?.invoice_portion}%` : "0",
    // },
    // {
    //   label: "Description",
    //   renderCell: item =>
    //     item?.description ? capitalizeFirstLetter(item?.description) : "-",
    // },
    // {
    //   label: "Status",
    //   renderCell: item => (
    //     <div>
    //       <div
    //         className={`font-13 ${
    //           item?.status === 1 ? "status-active" : "status-inactive"
    //         }`}
    //       >
    //         {item?.status === 1 ? "Active" : "Inactive"}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "paymentterms_edit"
              ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchPayTermTemplate({
        params: `${search ? `&searchText=${search}` : "&searchText"}${page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
    dispatch(driverSet("", false))
  }, [refresh, status, search, series, page, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSeriesChange = id => {
    setSeries(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Settings"
              breadcrumbObject={[
                { title: "Settings", link: "/settings" },
                { title: crumb || "Payment Terms", link: "/settings" },
                { title: "Payment Terms Template", link: "/settings/payment-terms/template" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "paymentterms_create"
            ) && (
                <EditPayTermsTemplate
                  key={"x"}
                  onUpdate={handleUpdate}
                  onReset={handleReset}
                  editValue={editClass}
                  buttonLabel="+&nbsp; Payment Terms Template"
                  className="px-2 mb-3 me-2 btn btn-primary"
                />
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <InventoryFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleSeriesChange={handleSeriesChange}
              sampleUrl={"download/class.xlsx"}
              importUrl={"class/import"}
              showExport={false}
              isSeries={false}
              showStatus={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {classData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={classData?.data?.data}
                    paginate={classData?.data}
                    CurrentPage={page}
                    columns={columns}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="20% 70% 10%"
                    mobileWidth="40% 40% 20%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PaymentTermsTemplateSearch
